import { Form, Input as InputField, InputNumber, message } from "antd";
import React, { useState } from "react";
import Dropdown from "./../common/dropdown";
import Button from "./../common/button";
import { billingAddress, updateBusiness } from "../../api/payment";
import { useDispatch } from "react-redux";
import { discountValue } from "../../store/slices/paymentSlice";
import Visa from "./../common/visa";
import {
  CardCvcElement,
  CardNumberElement,
  CardExpiryElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { colors } from "../../share/constants/enums";
import { Spin } from "antd";
import visaCard from "./../../assets/icons/Visa.svg";
import masterCard from "./../../assets/icons/mastercard.svg";
import Checkbox from "../common/checkBox";
import { LoadingOutlined } from "@ant-design/icons";
import { generateToken } from "../../api/auth";
import { UsaStates } from "usa-states";

const BillingAddress = ({ check }) => {
  const [isApplied, setIsApplied] = useState(false);
  const [loader, setLoader] = useState(false);
  const [cardSave, setCardSave] = useState(false);
  const dispatch = useDispatch();
  const stripe = useStripe();
  const [value, setValue] = useState({
    discount: "",
  });
  const elements = useElements();
  const usStates = new UsaStates();

  const onFinish = async (values) => {
    setLoader(true);
    if (!stripe || !elements) {
      return;
    }
    setCardSave(true);
    const cardElementData = elements.getElement(CardNumberElement);
    const result = await stripe.createToken(cardElementData);
    if (result.error) {
      message.error(result?.error?.message);
      setLoader(false);
    } else {
      const payload = values.coupon
        ? {
            card: {
              token: result.token.id,
            },
            billingAddress: {
              firstName: values.firstName,
              lastName: values.lastName,
              streetAddress: values.streetAddress,
              suiteNumber: values?.suiteNumber?.toString(),
              zipCode: values?.zipCode?.toString(),
              state: values.state,
              city: values.city,
            },
            coupon: value.discount,
          }
        : {
            card: {
              token: result.token.id,
            },
            billingAddress: {
              firstName: values.firstName,
              lastName: values.lastName,
              streetAddress: values.streetAddress,
              suiteNumber: values?.suiteNumber?.toString(),
              zipCode: values?.zipCode?.toString(),
              state: values.state,
              city: values.city,
            },
          };

      try {
        const res = await billingAddress(payload);
        if (res) {
          message.success("Payment Successful");

          const businessUpdate = await updateBusiness({ isSetup: true });

          const regToken = await generateToken();
          window.open(regToken?.url, "_self");
          if (businessUpdate) {
            localStorage.setItem("businessId", businessUpdate?._id);
          }
        }
      } catch (error) {
        message.error(error);
      } finally {
        setLoader(false);
      }
    }
  };

  const handleOnChange = (e) => {
    setValue({ discount: e.target.value });
  };

  const handleApply = () => {
    dispatch(discountValue(value));
    setIsApplied(true);
  };

  return (
    <>
      <div
        className={
          loader
            ? "flex flex-col items-start w-full lg:items-start opacity-30 "
            : "flex flex-col items-start w-full lg:items-start"
        }
      >
        <div className="w-full ">
          <div className="flex justify-start w-full mb-3">
            <p className="text-heading font-medium">Billing Address</p>
          </div>
          <Form onFinish={onFinish}>
            <div className="w-full md:grid md:grid-cols-2 md:gap-2 md:content-start lg:grid lg:grid-cols-2 lg:gap-2 lg:content-start">
              <Form.Item
                name="firstName"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Your First Name",
                  },
                ]}
              >
                <InputField
                  className={"w-full h-5.4 sm:w-31 md:w-full"}
                  placeholder="First Name"
                />
              </Form.Item>
              <Form.Item
                name="lastName"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Your Last Name",
                  },
                ]}
              >
                <InputField
                  className={"w-full h-5.4 sm:w-31 md:w-full"}
                  placeholder="Last Name"
                />
              </Form.Item>
              <Form.Item
                name="streetAddress"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Your Street Address",
                  },
                ]}
              >
                <InputField
                  className={"w-full h-5.4 sm:w-31 md:w-full"}
                  placeholder="Street Address"
                />
              </Form.Item>
              <div className="md:grid md:grid-cols-2 md:gap-2 md:w-full">
                <Form.Item
                  className="lg:w-full"
                  name="suiteNumber"
                  rules={[{ required: false, message: "field is required" }]}
                >
                  <InputNumber
                    className={"w-full h-5.6 flex items-center rounded-lg"}
                    controls={false}
                    placeholder="Suite Number"
                  />
                </Form.Item>
                <Form.Item
                  className="lg:w-full"
                  name="zipCode"
                  rules={[
                    { required: false, message: "field is required" },
                    {
                      pattern: /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
                      message: "Please enter a positive number",
                    },
                  ]}
                >
                  <InputNumber
                    className={"w-full h-5.4 flex items-center rounded-lg"}
                    type="number"
                    controls={false}
                    placeholder="ZIP Code"
                  />
                </Form.Item>
              </div>
              <div>
                <Form.Item
                  name="city"
                  className="w-full rounded-md"
                  rules={[
                    { required: true, message: "Please enter your city" },
                  ]}
                >
                  <InputField placeholder="City" className="h-5.4" />
                </Form.Item>
              </div>
              <div>
                <Form.Item
                  className="w-full rounded-md lg:w-full"
                  name="state"
                  rules={[
                    { required: true, message: "Please enter your state" },
                  ]}
                >
                  <Dropdown placeholder="State" data={usStates?.states} />
                </Form.Item>
              </div>
            </div>
            <div className="lg:flex">
              <p className="text-primaryPurple font-bold text-lg lg:w-15">
                Promo Code:
              </p>
              <div className="grid grid-cols-2 gap-1 lg:flex lg:w-50">
                <Form.Item className="lg:w-full" name="coupon">
                  <InputField
                    name="discount"
                    onChange={handleOnChange}
                    value={value.discount}
                    className="w-full h-5.4 lg:w-20"
                  />
                </Form.Item>

                <Form.Item className="lg:w-full">
                  {check === "correct" ? (
                    <p className="text-success">
                      ✅ Coupon code applied successfully!
                    </p>
                  ) : (
                    <Button
                      onClick={handleApply}
                      className="w-full bg-primaryPurple lg:w-16"
                      title="Apply"
                    />
                  )}
                </Form.Item>
              </div>
            </div>

            {loader ? (
              <div className="flex items-center justify-center !opacity-100">
                <Spin indicator={<LoadingOutlined />} />
              </div>
            ) : (
              ""
            )}

            <div className="border-boxGrey border-solid rounded-sm shadow-md p-2 md:flex md:flex-col md:space-y-2 mb-3">
              <p className="text-lg font-bold text-primaryPurple">
                Payment Method
              </p>
              <div className="w-full flex flex-col items-center space-y-2 md:grid md:grid-cols-3 md:gap-0 md:space-y-0 2xl:grid-cols-3">
                <Visa
                  img1={masterCard}
                  img2={visaCard}
                  color={colors.primaryPurple}
                />
                {/* <AddCard color={{colors}.white} /> */}
              </div>
              <div className="space-y-1 mt-1 mb-1 md:flex md:mt-0 md:mb-0 md:space-y-0 md:space-x-1">
                <Form.Item
                  name={"holderName"}
                  className="w-full"
                  rules={[
                    {
                      required: true,
                      message: "field is required",
                    },
                  ]}
                >
                  <InputField
                    placeholder="Card Holder Name"
                    className="h-5.4 bg-inputFieldGrey border-none placeholder-placeHolderGrey"
                  />
                </Form.Item>
                <Form.Item
                  name="cardNumber"
                  className="bg-inputFieldGrey h-5.4 w-full rounded-sm flex flex-col justify-center pl-1"
                >
                  <div>
                    <CardNumberElement />
                  </div>
                </Form.Item>
                <Form.Item
                  name="cardExpiry"
                  className="bg-inputFieldGrey h-5.4 w-full rounded-sm flex flex-col justify-center pl-1"
                >
                  <CardExpiryElement />
                </Form.Item>
                <Form.Item
                  name="cardCVV"
                  className="bg-inputFieldGrey h-5.4 w-full rounded-sm flex flex-col justify-center pl-1"
                >
                  <CardCvcElement />
                </Form.Item>
              </div>
              {cardSave && (
                <div className="text-sm text-primaryPurple">
                  * Your Card details have been saved, You will be charged on
                  1st January 2024.
                </div>
              )}
              <div className="flex flex-col md:flex md:flex-row md:justify-between">
                <Form.Item>
                  <Checkbox
                    onChecked={() => ""}
                    description="Save Card Details for Monthly Vendor Membership Fee"
                  />
                </Form.Item>
                <Form.Item className="">
                  <Button
                    disabled={loader}
                    title="Pay Now"
                    className="bg-primaryPurple w-16"
                    htmlType="submit"
                  />
                </Form.Item>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default BillingAddress;
